import { Box } from "@theme/components/ThemeUi";

import type { ThemeUIStyleObject } from "@theme/components/ThemeUi";
import type { FC } from "react";

export interface FieldLabelProps {
  label: string;
  error?: boolean | string;
  "data-testid"?: string;
  className?: string;
  sx?: ThemeUIStyleObject;
  id?: string;
}

/**
 * @deprecated Use `FieldLabelNew` instead.
 */
export const FieldLabel: FC<FieldLabelProps> = ({
  label,
  error = false,
  "data-testid": dataTestId,
  className,
  sx,
  id,
}) => (
  <Box
    className={className}
    data-role="label"
    data-testid={dataTestId}
    id={id}
    sx={{
      variant: "forms.fieldLabel",
      color: error ? "textError" : "textLevel3",
      mb: "s200",
      ...sx,
    }}
  >
    {label}
  </Box>
);
